import { type FC, type RefObject } from "react";
import { SelectBox } from "@root/shared/components/SelectBox";
import { SectionTitle } from "@userFrontend/features/withdrawal/components/EnqueteReasonInputs/uiParts/SectionTitle";
import { SectionWithTitleAndLabel } from "@userFrontend/components/SectionWithTitleAndLabel";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import { TextArea } from "@root/shared/components/TextArea";
import { Icon } from "@root/shared/components/Icon";
import { EntryClientSelect } from "@userFrontend/features/withdrawal/components/EnqueteReasonInputs/uiParts/EntryClientSelect";
import { Label } from "@root/shared/components/Label";
import { type JobEntry, type Option } from "./type";
import * as styles from "./styles.css";

type PresentationProps = {
  elementRef: RefObject<HTMLDivElement>;
  withdrawalReasonOptions: Option[];
  selectedReason: string | undefined;
  reasonText: string | undefined;
  handleChangeSelectedReason: (value: string) => void;
  handleReasonTextChange: (value: string) => void;
  thinkingEntriesWithoutUserEmployed: JobEntry[];
  selectedEntryIds: number[];
  handleChangeSelectedEntryId: (entryId: number, isChecked: boolean) => void;
  isOtherSelected: boolean;
  isRejobEmploymentWithEntriesSelected: boolean;
  isValid: boolean;
};

export const Presentation: FC<PresentationProps> = ({
  elementRef,
  withdrawalReasonOptions,
  selectedReason,
  reasonText,
  handleChangeSelectedReason,
  handleReasonTextChange,
  thinkingEntriesWithoutUserEmployed,
  selectedEntryIds,
  handleChangeSelectedEntryId,
  isOtherSelected,
  isRejobEmploymentWithEntriesSelected,
  isValid,
}) => {
  return (
    <div ref={elementRef}>
      <SectionTitle text="退会理由" />
      <div className={styles.container}>
        <SectionWithTitleAndLabel
          isRequired
          title="最も当てはまる退会理由を1つ教えてください"
          containerRef={null}
        >
          <SelectBox
            name="user_withdrawal_reason[reason_type]"
            value={selectedReason}
            onChange={(e) => handleChangeSelectedReason(e.target.value)}
            options={withdrawalReasonOptions}
            selected={!!selectedReason}
            placeholder="選択してください"
            className={styles.selectBox}
          />

          {isRejobEmploymentWithEntriesSelected && (
            <div className={styles.commonInner}>
              <div className={styles.inputOuter}>
                <SectionWithTitleAndLabel isRequired title="選考中の応募" containerRef={null}>
                  <EntryClientSelect
                    handleChangeSelectedEntryId={handleChangeSelectedEntryId}
                    checkedJobEntryIds={selectedEntryIds}
                    thinkingEntriesWithoutUserEmployed={thinkingEntriesWithoutUserEmployed}
                  />
                </SectionWithTitleAndLabel>
              </div>
            </div>
          )}
          {isOtherSelected && (
            <div className={styles.otherInner}>
              <div className={styles.titleOuter}>
                <h3 className={styles.title}>その他の理由</h3>
                <Label theme="lightGray" size="small" className={styles.label}>
                  <span>任意</span>
                </Label>
              </div>
              <TextArea
                id="other_reason"
                name="user_withdrawal_reason[reason_text]"
                value={reasonText}
                onChange={(e) => handleReasonTextChange(e.target.value)}
                className="withdrawal_other_reason"
                size="large"
                placeholder="その他の理由を入力してください"
              />
            </div>
          )}

          <GuidanceBox themeColor="red">
            <div className={styles.guidanceBox}>
              <Icon name="attention" fontSize="16px" />
              <p>
                選考中の応募が残っている場合、企業には「辞退」の通知が届きます。ただし、リジョブから確認のご連絡をさせていただく可能性があります。
              </p>
            </div>
          </GuidanceBox>
        </SectionWithTitleAndLabel>
      </div>
      <input type="hidden" id="valid" value={isValid ? "true" : "false"} />
    </div>
  );
};
